/**
 * Answer parsing helpers for restoring stored questionnaire answers into SurveyJS values.
 */

/**
 * Parses a stored multi-select (checkbox) answer into an array of selected values.
 *
 * New answers are persisted as a JSON array so that option values containing the
 * delimiter (e.g. a comma inside the option text) survive the save/reload round-trip.
 * Legacy answers were stored as a plain comma-separated string; those are still
 * supported via a fallback split so previously saved data continues to load.
 *
 * @param {string} storedValue - The raw value read back from storage.
 * @returns {string[]} The selected option values.
 */
export function parseCheckboxAnswer(storedValue) {
    if (typeof storedValue !== 'string') {
        return Array.isArray(storedValue) ? storedValue : [];
    }

    const trimmed = storedValue.trimStart();
    if (trimmed.startsWith('[')) {
        try {
            const parsed = JSON.parse(storedValue);
            if (Array.isArray(parsed)) {
                return parsed;
            }
        } catch (e) {
            // Not valid JSON - fall through to legacy comma-separated parsing.
            console.warn('parseCheckboxAnswer: failed to parse stored value as JSON, falling back to comma-separated parsing.', e);
        }
    }

    return storedValue.split(',');
}
